import React from "react";
import ReactDOM from "react-dom/client";

import {
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";

import {
  HelmetProvider,
} from "react-helmet-async";

import {
  Toaster,
} from "sonner";

import ErrorBoundary from "@/components/common/ErrorBoundary";

import "@/index.css";
import "@/App.css";

const queryClient =
  new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60_000,
        refetchOnWindowFocus: false,
      },
    },
  });

export function mountApp(App) {
  const root =
    ReactDOM.createRoot(
      document.getElementById("root"),
    );

  root.render(
    <QueryClientProvider
      client={queryClient}
    >
      <HelmetProvider>
        <ErrorBoundary
          key={window.location.pathname}
        >
          <App />

          <Toaster
            position="top-right"
            richColors
            closeButton
            duration={4000}
          />
        </ErrorBoundary>
      </HelmetProvider>
    </QueryClientProvider>,
  );
}